export { default as TopBar } from './TopBar';
export { default as Header } from './Header';
export { default as HeroSlider } from './HeroSlider';
export { default as AboutSection } from './AboutSection';
export { default as OpeningHoursSection } from './OpeningHoursSection';
export { default as SpecialMenuSection } from './SpecialMenuSection';
export { default as VideoSection } from './VideoSection';
export { default as WhyChooseUsSection } from './WhyChooseUsSection';
export { default as TestimonialsSection } from './TestimonialsSection';
export { default as VouchersSection } from './VouchersSection';
export { default as ChefSection } from './ChefSection';
export { default as BookingSection } from './BookingSection';
export { default as BlogSection } from './BlogSection';
export { default as GallerySection } from './GallerySection';
export { default as LocationSection } from './LocationSection';
export { default as Footer } from './Footer';
export { default as RestaurantProducts } from './RestaurantProducts';

export { default as StatsSection } from './NoirCoffe/STATS';
export { default as StorySection } from './NoirCoffe/STORY';
export { default as ProcessSection } from './NoirCoffe/PROCESS';

export { default as NAVBAR_COFFEE } from "./NAVBAR_COFFEE";
export { default as HERO_COFFEE } from "./HERO_COFFEE";
export { default as MARQUEE_COFFEE } from "./MARQUEE_COFFEE";
export { default as STATS_COFFEE } from "./STATS_COFFEE";
export { default as MENU_COFFEE } from "./MENU_COFFEE";
export { default as STORY_COFFEE } from "./STORY_COFFEE";
export { default as PROCESS_COFFEE } from "./PROCESS_COFFEE";
export { default as CTA_BAND_COFFEE } from "./CTA_BAND_COFFEE";
export { default as FOOTER_COFFEE } from "./FOOTER_COFFEE";
export { CoffeeBean } from "./CoffeeBean";

export { default as OpeningHours } from './OpeningHours';

export { default as Div } from './Div';
export { HeroParapharma } from './HeroParapharma';
export { TrustBar } from './TrustBar';
export { CategoriesSection } from './CategoriesSection';
export { ProductsSection } from './ProductsSection';
export { TestimonialsParapharma } from './TestimonialsParapharma';
export { CTASection } from './CTASection';
export { ParapharmaFooter } from './ParapharmaFooter';

export { default as Navbar } from './Navbar';
export { default as Hero } from './Hero';
export { default as Marquee } from './Marquee';
export { default as Collections } from './Collections';
export { default as Products } from './Products';
export { default as EditorialBanner } from './EditorialBanner';
export { default as Newsletter } from './Newsletter';
export { default as SocialLinks } from './SocialLinks';
